import type { AyantDroitStatut } from '@cpce/shared';
import { User } from 'lucide-react';
import { useSetBeneficiaryStatus } from '@/api/beneficiaries/beneficiaries.mutations';
import { Badge, BadgeColor } from '@/components/Badge';
import { BadgeSelect } from '@/components/BadgeSelect';
import { Title } from '@/components/Title';
import type { BeneficiaryFormatted } from '../beneficiaries.types';
import {
  ACharge,
  AYANT_DROIT_STATUT_OPTIONS,
} from '../employees-beneficiaries/columns/employees-beneficiaries-columns';

interface BeneficiaryProfileProps {
  beneficiary: BeneficiaryFormatted;
  infoBlocks: {
    id: string;
    icon: React.ReactNode;
    text?: string;
  }[];
}

export function BeneficiaryProfile(props: BeneficiaryProfileProps) {
  const { beneficiary, infoBlocks } = props;
  const { mutate: setBeneficiaryStatus } = useSetBeneficiaryStatus(beneficiary.id);

  return (
    <div className="flex justify-between gap-2">
      <div className="flex gap-2">
        <ProfilePicture />
        <div className="flex flex-col justify-between py-1">
          <Title>{beneficiary.fullName ?? '-'}</Title>
          <div className="flex gap-4">
            {infoBlocks.map((block) => (
              <div key={block.id} className="flex items-center gap-1 text-gray-700">
                {block.icon}
                <div className="text-sm font-medium">{block.text || '-'}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Badge color={beneficiary.isActive ? BadgeColor.GREEN : BadgeColor.GRAY}>
          {beneficiary.isActive ? 'Actif' : 'Archivé'}
        </Badge>
        <BadgeSelect<AyantDroitStatut>
          value={beneficiary.statut}
          onChange={(value) => {
            if (!value) return;
            setBeneficiaryStatus(value.value);
          }}
          options={AYANT_DROIT_STATUT_OPTIONS}
        />
        {beneficiary.aCharge !== null && <ACharge value={beneficiary.aCharge} />}
      </div>
    </div>
  );
}

function ProfilePicture() {
  return (
    <div className="flex size-16 rounded-full bg-gray-200 items-center justify-center">
      <User className="size-15" />
    </div>
  );
}
